import RemoveHubDialog from './RemoveHubDialog';

export default RemoveHubDialog;
